// @ts-nocheck
/**
 * 6529.io API
 * This is the API interface description. Brief terminology overview and an authentication example can be found at <a href=\"https://6529.io/about/api\">https://6529.io/about/api</a>.
 *
 * OpenAPI spec version: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { ApiGroupCicFilter } from '../models/ApiGroupCicFilter';
import { ApiGroupLevelFilter } from '../models/ApiGroupLevelFilter';
import { ApiGroupOwnsNft } from '../models/ApiGroupOwnsNft';
import { ApiGroupRepFilter } from '../models/ApiGroupRepFilter';
import { ApiGroupTdhFilter } from '../models/ApiGroupTdhFilter';
import { ApiXTdhGrant } from '../models/ApiXTdhGrant';
import { HttpFile } from '../http/http';

export class ApiGroupDescription {
    'tdh': ApiGroupTdhFilter;
    'rep': ApiGroupRepFilter;
    'cic': ApiGroupCicFilter;
    'level': ApiGroupLevelFilter;
    'owns_nfts': Array<ApiGroupOwnsNft>;
    'identity_group_id': string | null;
    'identity_group_identities_count': number;
    'excluded_identity_group_id': string | null;
    'excluded_identity_group_identities_count': number;
    'is_beneficiary_of_grant_id': string | null;
    'is_beneficiary_of_grant': ApiXTdhGrant | null;

    static readonly discriminator: string | undefined = undefined;

    static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
        {
            "name": "tdh",
            "baseName": "tdh",
            "type": "ApiGroupTdhFilter",
            "format": ""
        },
        {
            "name": "rep",
            "baseName": "rep",
            "type": "ApiGroupRepFilter",
            "format": ""
        },
        {
            "name": "cic",
            "baseName": "cic",
            "type": "ApiGroupCicFilter",
            "format": ""
        },
        {
            "name": "level",
            "baseName": "level",
            "type": "ApiGroupLevelFilter",
            "format": ""
        },
        {
            "name": "owns_nfts",
            "baseName": "owns_nfts",
            "type": "Array<ApiGroupOwnsNft>",
            "format": ""
        },
        {
            "name": "identity_group_id",
            "baseName": "identity_group_id",
            "type": "string",
            "format": ""
        },
        {
            "name": "identity_group_identities_count",
            "baseName": "identity_group_identities_count",
            "type": "number",
            "format": "int64"
        },
        {
            "name": "excluded_identity_group_id",
            "baseName": "excluded_identity_group_id",
            "type": "string",
            "format": ""
        },
        {
            "name": "excluded_identity_group_identities_count",
            "baseName": "excluded_identity_group_identities_count",
            "type": "number",
            "format": "int64"
        },
        {
            "name": "is_beneficiary_of_grant_id",
            "baseName": "is_beneficiary_of_grant_id",
            "type": "string",
            "format": ""
        },
        {
            "name": "is_beneficiary_of_grant",
            "baseName": "is_beneficiary_of_grant",
            "type": "ApiXTdhGrant",
            "format": ""
        }    ];

    static getAttributeTypeMap() {
        return ApiGroupDescription.attributeTypeMap;
    }

    public constructor() {
    }
}

